import {
  FilterOnlyFields,
  PropertyStateFields,
  SpatialFiltersInput,
} from '@hcs/types';

export const SPATIAL_FILTERS_TO_PROPERTY_STATE_FIELDS: Partial<
  Record<keyof SpatialFiltersInput, PropertyStateFields | FilterOnlyFields>
> = {
  conditionClass: PropertyStateFields.condition,
  basement: PropertyStateFields.basementHas,
  // conditionClass: PropertyStateFields,
  // listDateOrSaleDate: PropertyStateFields,
  maxAvmPrice: PropertyStateFields.currentValue,
  maxBaths: PropertyStateFields.bathrooms,
  maxBathsWithHalfs: PropertyStateFields.bathrooms,
  maxBeds: PropertyStateFields.bedrooms,
  maxBestHighSchoolPercentile: 'bestHighSchoolPercentile',
  maxBestMiddleSchoolPercentile: 'bestMiddleSchoolPercentile',
  maxBestPrimarySchoolPercentile: 'bestPrimarySchoolPercentile',
  maxCrimeCountyPercentile: 'crimePercentile',
  maxLeaseDate: PropertyStateFields.lastCloseDateRental,
  maxLeasePrice: PropertyStateFields.lastClosePriceRental,
  maxListDate: PropertyStateFields.currentListDate,
  maxListPrice: PropertyStateFields.currentListingPrice,
  maxLotArea: PropertyStateFields.lotSize,
  maxParkingSpots: PropertyStateFields.parkingTotal,
  // maxPricePerSqft50: PropertyStateFields,
  maxRentalAvmPrice: PropertyStateFields.currentValueRental,
  maxRentalListDate: PropertyStateFields.currentListDateRental,
  maxRentalListPrice: PropertyStateFields.currentListingPriceRental,
  maxRentalYield: PropertyStateFields.rentalYield,
  maxSaleDate: PropertyStateFields.lastCloseDate,
  maxSalePrice: PropertyStateFields.lastClosePrice,
  maxSqft: PropertyStateFields.livingArea,
  maxStories: PropertyStateFields.stories,
  maxYearBuilt: PropertyStateFields.yearBuilt,

  minAvmPrice: PropertyStateFields.currentValue,
  minBaths: PropertyStateFields.bathrooms,
  minBathsWithHalfs: PropertyStateFields.bathrooms,
  minBeds: PropertyStateFields.bedrooms,
  minBestHighSchoolPercentile: 'bestHighSchoolPercentile',
  minBestMiddleSchoolPercentile: 'bestMiddleSchoolPercentile',
  minBestPrimarySchoolPercentile: 'bestPrimarySchoolPercentile',
  minCrimeCountyPercentile: 'crimePercentile',
  minLeaseDate: PropertyStateFields.lastCloseDateRental,
  minLeasePrice: PropertyStateFields.lastClosePriceRental,
  minListDate: PropertyStateFields.currentListDate,
  minListPrice: PropertyStateFields.currentListingPrice,
  minLotArea: PropertyStateFields.lotSize,
  minParkingSpots: PropertyStateFields.parkingTotal,
  // minPricePerSqft50: PropertyStateFields,
  minRentalAvmPrice: PropertyStateFields.currentValueRental,
  minRentalListDate: PropertyStateFields.currentListDateRental,
  minRentalListPrice: PropertyStateFields.currentListingPriceRental,
  minRentalYield: PropertyStateFields.rentalYield,
  minSaleDate: PropertyStateFields.lastCloseDate,
  minSalePrice: PropertyStateFields.lastClosePrice,
  minSqft: PropertyStateFields.livingArea,
  minStories: PropertyStateFields.stories,
  minYearBuilt: PropertyStateFields.yearBuilt,

  mlsState: PropertyStateFields.currentStatus,
  mlsStateGroup: PropertyStateFields.currentStatus,
  pool: PropertyStateFields.pool,
  propertyTypeEnum: PropertyStateFields.propertyType,
  rentalMlsState: PropertyStateFields.currentStatusRental,
  rentalMlsStateGroup: PropertyStateFields.currentStatusRental,
};

export const PROPERTY_STATE_FIELDS_TO_SPATIAL_FILTERS: Partial<
  Record<PropertyStateFields | FilterOnlyFields, (keyof SpatialFiltersInput)[]>
> = Object.entries(SPATIAL_FILTERS_TO_PROPERTY_STATE_FIELDS).reduce<
  Partial<
    Record<
      PropertyStateFields | FilterOnlyFields,
      (keyof SpatialFiltersInput)[]
    >
  >
>((acc, [spatialFilterKey, propertyStateField]) => {
  if (!acc[propertyStateField]) {
    acc[propertyStateField] = [];
  }
  acc[propertyStateField].push(
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    spatialFilterKey as keyof typeof SPATIAL_FILTERS_TO_PROPERTY_STATE_FIELDS,
  );
  return acc;
}, {});
